module.exports = __webpack_public_path__ + "img/c02_buildingtechdeserttraining_Normal_ua.9f4ca3d9.webp";